import { render, staticRenderFns } from "./EffectModeSelector.vue?vue&type=template&id=776c1466&"
import script from "./EffectModeSelector.vue?vue&type=script&lang=js&"
export * from "./EffectModeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports